export default __webpack_public_path__ + "static/media/krakowwieliczka.8bad87dc.svg";